import { useUpdate } from "../../../../api/react-query"

export function useEditConfigType() {
    const {
        mutateAsync: editConfigTypes,
        isLoading: isEditing,
        error
    } = useUpdate({
        url: 'config/type',
        apiVersion: 'v1',
        msg: 'updated successfully'
    })
    return {
        editConfigTypes,
        isEditing,
        error
    }
}
